import { IconButton, AppBar, Toolbar, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button } from "@material-ui/core";
import * as React from "react";
import { Theme } from "@material-ui/core/styles";
import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { Route, RouteComponentProps, Switch } from "react-router";
import { config } from "src/config";
import { observer } from "mobx-react";
import { history } from "src/history.js";
import { permissionsStore } from '.';

const styles = ({ typography }: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: 'hidden'
        },
        table: {
            height: "100%",
            flex: 1,
            fontFamily: "inherit",
        },
        tableIconCell: {
            display: "flex",
            justifyContent: "center",
        },
        tableIconHeader: {
            marginRight: "1rem",
        },
        tableDefaultCell: {
            marginRight: ".25rem",
            marginLeft: ".25rem",
            display: "flex",
            alignItems: "center",
            fontFamily: typography.fontFamily,
        },
        tableDefaultHeader: {
            fontFamily: typography.fontFamily,
        },
        content: {
            flex: 1,
            display: "flex",
        },
        subheaderRow: {
            backgroundColor: '#cddadb',
        }
    });

@observer
class Permissions extends React.Component<any> {

    constructor(props: any) {
        super(props);
    }


    public componentDidMount = async () => {
        await permissionsStore.getAllPermissionList();
        await permissionsStore.getAllPortalRoles();
    }

    public handleChange = (permission_id: number, role_id: number, active: number) => {
        permissionsStore.updateRolePermission(permission_id, role_id, active);
    }

    public submit = () => {
        return permissionsStore.savePermissions()
    }

    public getPermissionsContent = () => {
        const { classes } = this.props
        let current_component_name = ''
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Description</TableCell>
                        {permissionsStore.allPortalRoles.filter((role: any) => role.portal_role_id !== 1).map((role_info) => {
                                return (
                                    <TableCell key={role_info.portal_role_id}>{role_info.PortalRoleName}</TableCell>
                                )
                        })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {permissionsStore.allPermissionList.filter((permission_info) => permission_info.PermissionType !== 'navbar' && permission_info.PermissionCategory !== 'utils').map((permission_info) => {
                        const table_rows = [];
                        if (permission_info.PermissionCategory !== current_component_name) {
                            current_component_name = permission_info.PermissionCategory;

                            table_rows.push(
                                <TableRow key={current_component_name} className={classes.subheaderRow}>
                                    <TableCell>{current_component_name.charAt(0).toUpperCase() + current_component_name.slice(1) + " Permissions"}</TableCell>
                                    {permission_info.ActiveRoleList.map((permission_role_info) => (
                                        <TableCell key={permission_role_info.role_id} />
                                    ))}
                                </TableRow>
                            );
                        }

                        table_rows.push(
                            <TableRow key={permission_info.permission_id}>
                                <TableCell>{permission_info.PermissionDescription}</TableCell>
                                {permission_info.ActiveRoleList.filter((role: any) => role.role_id !== 1).map((permission_role_info) => (
                                    <TableCell key={permission_role_info.role_id}>
                                        <Checkbox
                                            checked={Boolean(permission_role_info.Active)}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onChange={(event) => this.handleChange(permission_info.permission_id, permission_role_info.role_id, event.target.checked ? 1 : 0)}
                                        />
                                    </TableCell>
                                ))}
                            </TableRow>
                        );

                        return table_rows;
                    })}
                </TableBody>
            </Table>
        )
    }

    public render() {
        const { classes } = this.props;
        if (!permissionsStore.allPermissionList || !permissionsStore.allPortalRoles) {
            return (<div>loading</div>)
        }


        return (
            <div>
                <Button
                    classes={{ root: classes.submitButton }}
                    onClick={this.submit}
                    variant='contained'
                >
                    Submit
                </Button>
                {this.getPermissionsContent()}
            </div>
        );
    }

}

export default withStyles(styles, { withTheme: true })(Permissions);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Permissions/Permissions.tsx